const addressComponentRequired = state => (ClientId, ClientLocationId) =>
	ClientId === 'Other' || ClientLocationId === 'Other' || !state.contactFound;

export { addressComponentRequired };
